import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {OidcSecurityProxyService} from '@app/core/service/oidc.security.proxy.service';
import {AuthenticationService} from '@app/core/service/authentication.service';
import {LoginResponse} from 'angular-auth-oidc-client/lib/login/login-response';
import {Router} from '@angular/router';

@Component({
    selector: 'ngc-auth-oauth',
    templateUrl: './auth-oauth.component.html',
    styleUrls: ['./auth-oauth.component.scss']
})
export class AuthOauthComponent implements OnInit, OnDestroy {

    private subscriptions: Subscription[] = [];

    constructor(
        private authenticationService: AuthenticationService,
        private oidcSecurityProxyService: OidcSecurityProxyService,
        private router: Router
    ) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.oidcSecurityProxyService.checkAuth()
                .subscribe((data: LoginResponse) => {
                    if (data.isAuthenticated) {
                        const returnUrl = this.router.routerState.snapshot.root.queryParams['redirect_uri'];
                        this.authenticationService.getXAuthToken(returnUrl);
                    } else {
                        this.router.navigate(['/']);
                    }
                }, () =>
                    this.router.navigate(['/'])
                )
        );
    }

    public ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
